/**
 * useReasonTypeListScreen.js
 * --------------------------
 * Headless Hook for Inquiry Reason Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as reasonTypeApi from '../api/reasonTypeApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function useReasonTypeListScreen() {
  const master = useMasterList({
    entityName: 'Inquiry Reason',
    apiClient: reasonTypeApi.reasonTypeClient,
    fetchList: reasonTypeApi.listReasonTypes,
    archiveItem: reasonTypeApi.archiveReasonType,
    deleteItem: reasonTypeApi.deleteReasonType,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'reason-type',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Inquiry Reason Master Registry',
        subtitle: 'Enterprise Inquiry Closure & Drop Classifications',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Reason Name', accessor: 'name' },
          { header: 'Abbreviation / Code', accessor: 'short_name' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
